export const tabMenuScroll = (element) => {
    // Get the viewport width
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // Set navbar offset
    let offset = document.querySelector('.site-header.sticky');
    offset = offset ? offset.offsetHeight : 0;

    if(vw <= 991) { //Breakpoint for TabPanel
        let finalOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: finalOffset,
        });

    } else {

        var tabPanel = document.querySelector('.wp-block-rbt-tabpanel.active');
        if(tabPanel) {
          let finalOffset = tabPanel.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
              top: finalOffset,
              behavior: "smooth"
          });
        }
    }
}

export const doTabMenuClick = (e, fromHistory) => {
  e.preventDefault();
  var li = e.target.tagName === "LI" ? e.target : e.target.closest("li");
  var tabTargetID = li.getAttribute("data-tab-trigger");
  var tabTarget = document.getElementById(tabTargetID);
  var url = e.target.hasAttribute('href') ? e.target.getAttribute('href') : li.querySelector('a').getAttribute('href');
  //prettier entity encoding is preventing me from using && in a template literal :/
  if(tabTarget){
    if(url){
      var parent = tabTarget.closest(".rbt-tabpanels");
      var targets = parent.getElementsByClassName("q-tab-target");
      var controls = parent.getElementsByClassName("nav-tab");
      for(var i = 0; i < targets.length; i++){
        targets[i].classList.toggle("active", targets[i] === tabTarget);
      }
      /* Match controls to panels by data-tab-trigger, not index: the tabs attribute and the inner panel blocks can drift out of sync */
      for(var i = 0; i < controls.length; i++){
        var control = controls[i];
        var tabLink = control.querySelector('a');
        if(control.getAttribute('data-tab-trigger') === tabTargetID){
            control.classList.add("active");
            if(tabLink) tabLink.setAttribute('aria-selected', 'true');
            /* Clone Node deep */
            var mobileContent = control.querySelector('.mobile-content');
            if(!mobileContent){
              mobileContent = document.createElement('div');
              mobileContent.classList.add('mobile-content');
              mobileContent.innerHTML = tabTarget.innerHTML;
              control.appendChild(mobileContent);
            }
        } else {
            control.classList.remove("active");
            if(tabLink) tabLink.setAttribute('aria-selected', 'false');
            control.querySelectorAll('.mobile-content').forEach( item => {item.remove()} );
        }
      }
      /* Push only the #/tab/ hash: the saved href is an absolute pagelink that may not match this origin, which makes pushState throw */
      if(!fromHistory) window.history.pushState({}, document.title, url.slice(url.indexOf('#')));
      console.log("Scrolling to tab", li);
      tabMenuScroll(li);
      /* Move focus into the newly active panel so AT users get the change announced */
      if(tabTarget.focus) tabTarget.focus({ preventScroll: true });
    }
  }
}
export const setTabPanels = () => {
    var tabPanels = document.querySelectorAll(".wp-block-rbt-tabpanel");
    if(!tabPanels[0]) return;
    /* A tab is already open (e.g. the theme's loadActiveTab() honoured a #/tab/ deep link) - don't open a second one */
    if(document.querySelector(".wp-block-rbt-tabpanel.active")) return;
    tabPanels[0].classList.add("active");
    /* Do mobile here */
    var navTarget = tabPanels[0].hasAttribute('data-control-target') ? tabPanels[0].getAttribute('data-control-target') : tabPanels[0].id;
    var navTargetId = 'ctrl-' + navTarget;
    var navTarget = document.getElementById(navTargetId);
    if(navTarget){
      let mobileContent = navTarget.querySelector('.mobile-content');
      if(!mobileContent){
        mobileContent = document.createElement('div');
        mobileContent.classList.add('mobile-content');
        mobileContent.innerHTML = tabPanels[0].innerHTML;
        navTarget.appendChild(mobileContent);
      }

    }
}
